//3rd Party Components
import React, { Fragment } from 'react';
import AUpageAlert from '@gov.au/page-alerts';
import { useSelector } from "react-redux";

//Components
import Heading from '../components/CASA/Heading';

//Actions
import { getUrlSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getPortalUrl } from '../components/Portal/Utilities';
import { urlSearchValue } from '../components/Portal/Utilities';
import { getUserHomePage } from '../components/Portal/Utilities';

export const ActiveAlertPage = () => {
    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));

    let userdetails = useSelector(state => state.userdetails);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let draftarnsIndividual = useSelector(state => state.draftArnsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);

    //no org alerts required
    let from = urlSearchValue("from");
    let acftid = urlSearchValue("acftid");

    let userHomePage = getUserHomePage(srarnsIndividual, draftarnsIndividual, userdetails, tagsIndividual, acceptedSRsIndividual, participants);

    const setInnerHTML = (value) => {
        return { __html: value };
    };

    let showItems = false;

    const loc = getPortalUrl("/dashind", standalone, urlHome);

    let items = [
        {
            link: getPortalUrl("/" + userHomePage, standalone, urlHome),
            text: 'myCASA'
        },
        {
            link: getPortalUrl("/manageaircraftind", standalone, "/forms"),
            text: 'Manage Aircraft'
        },
        {
            link: getPortalUrl("/singleaircraft", standalone, "/forms") + "?from=" + {from} + "&casaorgid=&acftid=" + {acftid},
            text: 'Aircraft details'
        },
        {
            text: 'Transfer of ownership'
        }
    ];
    showItems = true;
    
    return (
        <Fragment>
            <Heading
                text='Manage Aircraft - Transfer of ownership'
                subtext=''
                breadcrumbs={items}
                showcrumbs={showItems}
            />

            <AUpageAlert as="error">
                <div id="systemError" aria-live="polite">
                    <br />
                    <h3>Unable to complete transfer online.</h3>
                    <p dangerouslySetInnerHTML={setInnerHTML("Unfortunately this transfer cannot be completed online. Please refer to <a href='https://www.casa.gov.au/aircraft/civil-aircraft-register/aircraft-registration/aircraft-register-forms-and-fees-aircraft-registration'>Form 027</a> to complete this transfer.")}></p>
                    <br />
                </div>
            </AUpageAlert>

            <div>
                <button className="btn-link au-direction-link au-direction-link--left" href={loc}>Return to myCASA</button>
            </div>

        </Fragment>

    );

}

